import Dexie from 'dexie';

export const DB_VERSION = 2;
export const DB_NAME = 'webmail';

export const db = new Dexie(DB_NAME);

export const startBoxes = async boxes => {

    const schema = {
        boxes: 'Box',
        ...boxes.reduce((obj, cur) => ({...obj, [cur.Box]: 'uid'}), {})
    };

    db.version(DB_VERSION).stores(schema);

    return db.open();
};

export const dryStart = async () => db.open();

export const dbExist = async () => {
    return Dexie.exists(DB_NAME);
}

export const clearWebmail = async () => {
    return Dexie.delete(DB_NAME);
}

export const tableExists = async table => {
    try {
        if (!db.isOpen()) {
            await db.open();
        }

        if (db.verno.toString() !== DB_VERSION.toString()) {
            return false;
        }
        return db.tables.filter(t => t.name === table).length > 0;
    } catch (e) {
        return false
    }

}
